module.exports = __webpack_public_path__ + "img/sidebar-cta-join.e1119531.svg";